import React from 'react';

import Loader from 'components/Loader/index';
import ContentfulFields from 'components/ContentfulFields/index';
import { get } from 'lodash';

import ContentfulClient from 'utils/ContentfulClient/index';
import { getDomainByHost } from 'utils/domainHelper';
import { fetchPage } from 'utils/contentfulUtils';

import { pages } from 'containers/Landing/constants';

import styles from './styles.scss';

class ServiceSuccess extends React.Component {
  state = {
    page: null,
  };

  successBannerRef = React.createRef();

  async componentDidMount() {
    const contentfulClient = new ContentfulClient();
    const domain = getDomainByHost(20);
    const page = await fetchPage(
      domain,
      contentfulClient,
      pages.serviceSuccess,
    );

    this.setState({ page: page.items[0].fields });

    window.scrollTo({
      top: this.successBannerRef.current.offsetTop - 300,
      behavior: 'smooth',
    });
  }

  render() {
    const { page } = this.state;

    return (
      <div ref={this.successBannerRef} className={styles.successBanner}>
        <Loader loading={!page}>
          {page &&
            page.contentModules.map((banner) => (
              <ContentfulFields
                type={get(banner, 'sys.contentType.sys.id')}
                document={banner}
                key={banner.sys.id}
              />
            ))}
        </Loader>
      </div>
    );
  }
}

export default ServiceSuccess;
